var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "执照全称",
      "prop": "partner_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入执照全称"
    },
    model: {
      value: (_vm.ruleForm.partner_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "partner_name", $$v)
      },
      expression: "ruleForm.partner_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "执照简称",
      "prop": "partner_abbreviation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入执照简称"
    },
    model: {
      value: (_vm.ruleForm.partner_abbreviation),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "partner_abbreviation", $$v)
      },
      expression: "ruleForm.partner_abbreviation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户行",
      "prop": "opening_bank"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入开户行"
    },
    model: {
      value: (_vm.ruleForm.opening_bank),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "opening_bank", $$v)
      },
      expression: "ruleForm.opening_bank"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户行账号",
      "prop": "bank_account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入开户行账号"
    },
    model: {
      value: (_vm.ruleForm.bank_account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "bank_account", $$v)
      },
      expression: "ruleForm.bank_account"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经营地址",
      "prop": "partner_address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入经营地址"
    },
    model: {
      value: (_vm.ruleForm.partner_address),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "partner_address", $$v)
      },
      expression: "ruleForm.partner_address"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "partner_contact"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联系电话"
    },
    model: {
      value: (_vm.ruleForm.partner_contact),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "partner_contact", $$v)
      },
      expression: "ruleForm.partner_contact"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法定代表人",
      "prop": "partner_represent"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入法定代表人"
    },
    model: {
      value: (_vm.ruleForm.partner_represent),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "partner_represent", $$v)
      },
      expression: "ruleForm.partner_represent"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册地址",
      "prop": "register_address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入注册地址"
    },
    model: {
      value: (_vm.ruleForm.register_address),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "register_address", $$v)
      },
      expression: "ruleForm.register_address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "执照代码",
      "prop": "partner_code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入执照代码"
    },
    model: {
      value: (_vm.ruleForm.partner_code),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "partner_code", $$v)
      },
      expression: "ruleForm.partner_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "简称编码",
      "prop": "abbreviation_code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入简称编码"
    },
    model: {
      value: (_vm.ruleForm.abbreviation_code),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "abbreviation_code", $$v)
      },
      expression: "ruleForm.abbreviation_code"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "税率",
      "prop": "tax_rate"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入税率"
    },
    model: {
      value: (_vm.ruleForm.tax_rate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "tax_rate", $$v)
      },
      expression: "ruleForm.tax_rate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "营业期限",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "date1"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.date1),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "date1", $$v)
      },
      expression: "ruleForm.date1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "date1"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.date2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "date2", $$v)
      },
      expression: "ruleForm.date2"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("长期")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "250px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id == ''),
      expression: "ruleForm.id == null || ruleForm.id == ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.submitFormupdate('ruleForm')
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc058042","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/JfmtGl/Jfmtgl_add.vue
// module id = null
// module chunks = 